/** 登入 */
export default {
  label: {
    code: '簡訊登入',
    pswd: '密碼登入'
  },
  phone: '手機號碼',
  password: '登入密碼',
  code: '{type}驗證',
  sms: '簡訊',
  img: '圖片',
  getCode: '發送',
  login: '登入',
  // 選擇商家
  choose: '選擇商家',
  // 提示
  agree: '未註冊的手機號碼將自動註冊。勾選即代表您同意並接受',
  agreement: '《商家平台用戶協議》',
  second: '秒',
  // 微信登入
  wx: '微信登入',
  // 活動管理平台
  activity_platform: {
    title: '活動管理平台',
    subtitle: '由簡到繁，無窮的變化及設置，滿足您的活動需求',
    features: [
      '通過-多個輪次，多個分類分組組合發布大型活動',
      '通過-人氣榜單為您的活動增加曝光量',
      '通過-加載廣告實現多形式推廣',
      '通過-多維度的評選，精準選出最佳的參加者',
      '通過-圖片、視頻的上傳展現出繽紛多彩的現場'
    ]
  },
  // 評選晉級
  evaluation: {
    title: '評選晉級',
    subtitle: '多維度評選實現最為公平正式的選拔評分',
    features: [
      '創建多維度的評分方案賦予不同的組別，複合式選拔',
      '評分、評判兩種評選方式供您選擇',
      '多評委同時評選、評分，實現公平的權威性',
      '學員評選成績篩選；晉級、淘汰一鍵式操作',
      '創建獎狀名次賦予優秀的學員'
    ]
  },
  // 精彩時刻
  moments: {
    title: '精彩時刻',
    subtitle: '圖片、視頻記錄活動中的精彩時刻瞬間',
    features: [
      '上傳圖片或者視頻，發布在手機端作為各方精彩時刻的留念',
      '通過標籤，分類不同的圖片和視頻，形成有效的管理',
      '圖片及視頻的下載可讓用戶永久保留住高光時刻'
    ]
  },
  // 人氣榜單
  popularity: {
    title: '人氣榜單',
    subtitle: '活動熱度通過榜單排名完美體現',
    features: [
      '點讚榜單，一人一票展現出活動的高人氣印象',
      '禮物榜單，為您所支持的人氣選手做出一份貢獻',
      '多階段榜單，展現出活動各個階段不同的人氣',
      '多組別榜單。展現出不同組別的高人氣學員'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/zh_tw/login.js